/* eslint-disable enforce-ids-in-jsx/missing-ids */
import React from 'react'

import { Global } from 'components/lib/DesignSystem/Icons'
import ExternalLink from 'components/lib/DesignSystem/Icons/ExternalLink'
import { Tooltip } from 'components/lib/DesignSystem/V3'

import {
  SourceBadge,
  SourceBadgesContainer,
  SourceCount,
  SourceLinkButton,
  SourceLinkLabel,
  SourcesTooltipContent,
  SourcesTooltipList,
  SourcesTooltipTitle,
} from '../styles'
import { getSourceLabel, openSourceUrl, SOURCE_ICON_BY_KIND } from '../utils'

const SourceBadgeList = ({ campaignId, sourcesByKind, sourceKindsToRender }) => (
  <SourceBadgesContainer
    id={`Psima_Dashboard_Sources_div-${campaignId}`}
    data-testid={`Psima_Dashboard_Sources_div-${campaignId}`}
  >
    {sourceKindsToRender.map((sourceKind) => {
      const kindSources = sourcesByKind[sourceKind]
      const count = kindSources.length
      const SourceIcon = SOURCE_ICON_BY_KIND[sourceKind] || Global
      const isSingleSource = count === 1
      const badgeId = `Psima_Dashboard_SourceBadge_${sourceKind}_div-${campaignId}`

      const badge = (
        <SourceBadge
          id={badgeId}
          data-testid={badgeId}
          role="button"
          tabIndex={0}
          onClick={(e) => openSourceUrl(e, kindSources[0].url)}
        >
          <SourceIcon
            id={`Psima_Dashboard_SourceIcon_${sourceKind}_icon-${campaignId}`}
            data-testid={`Psima_Dashboard_SourceIcon_${sourceKind}_icon-${campaignId}`}
            width="16px"
            height="16px"
            fill="var(--psima-source-icon-fill)"
            noDefaultFill
          />
          <SourceCount>{count}</SourceCount>
        </SourceBadge>
      )

      if (isSingleSource) {
        return <React.Fragment key={sourceKind}>{badge}</React.Fragment>
      }

      return (
        <Tooltip
          key={sourceKind}
          id={`Psima_Dashboard_SourceTooltip_${sourceKind}_tooltip-${campaignId}`}
          side="bottom"
          align="start"
          arrow
          content={
            <SourcesTooltipContent
              data-testid={`Psima_Dashboard_SourceTooltipContent_${sourceKind}_div-${campaignId}`}
            >
              <SourcesTooltipTitle>Explore sources</SourcesTooltipTitle>
              <SourcesTooltipList>
                {kindSources.map((source, idx) => (
                  <SourceLinkButton
                    key={`${source.url}-${idx}`}
                    type="button"
                    data-testid={`Psima_Dashboard_SourceLink_${sourceKind}_${idx}_button-${campaignId}`}
                    onClick={(e) => openSourceUrl(e, source.url)}
                  >
                    <SourceIcon
                      width="16px"
                      height="16px"
                      fill="var(--psima-source-icon-fill)"
                      noDefaultFill
                    />
                    <SourceLinkLabel>{getSourceLabel(source)}</SourceLinkLabel>
                    <ExternalLink width="14px" height="14px" />
                  </SourceLinkButton>
                ))}
              </SourcesTooltipList>
            </SourcesTooltipContent>
          }
        >
          {badge}
        </Tooltip>
      )
    })}
  </SourceBadgesContainer>
)

export default SourceBadgeList
